import React, { useState, useEffect } from "react";
import axios from "axios";
import AppModal from "./AppModal";

export default function ConsentBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const [modal, setModal] = useState({ isOpen: false, title: "", message: "", type: "info" });
  
  useEffect(() => {
    // Check if the user is logged in
    const token = localStorage.getItem("token");
    const hasConsentedLocal = localStorage.getItem("has_consented_policies");
    
    if (token) {
      // If logged in but hasn't consented in the backend (from login response) or local
      if (hasConsentedLocal !== "true") {
        setShowBanner(true);
      }
    } else {
      // If not logged in, check local storage
      if (hasConsentedLocal !== "true") {
        setShowBanner(true);
      }
    }
  }, []);

  const handleAccept = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        await axios.post(
          `${process.env.REACT_APP_API_URL || ""}/api/auth/consent/`,
          {},
          { headers: { Authorization: `Token ${token}` } }
        );
      } catch (err) {
        console.error("Error saving consent:", err);
        // Continue anyway to hide banner and store locally
      }
    }
    
    localStorage.setItem("has_consented_policies", "true");
    setShowBanner(false);
  };

  const showPolicies = () => {
    setModal({
      isOpen: true,
      title: "Políticas de Cookies y Habeas Data",
      message: "Al utilizar esta plataforma, aceptas el uso de cookies para mejorar tu experiencia y autorizas el tratamiento de tus datos personales conforme a la Ley 1581 de 2012 y nuestras políticas de privacidad y Habeas Data.",
      type: "info"
    });
  };

  if (!showBanner) return null;

  return (
    <>
      <div style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "#1e293b",
        color: "white",
        padding: "1rem",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        zIndex: 9999,
        boxShadow: "0 -4px 6px -1px rgba(0, 0, 0, 0.1)",
      }}>
        <div style={{ marginBottom: "1rem", textAlign: "center", fontSize: "0.875rem" }}>
          Utilizamos cookies para garantizar la mejor experiencia en nuestro sitio web. Además, de acuerdo con la Ley de Habeas Data, te informamos sobre nuestra política de tratamiento de datos personales.{" "}
          <button 
            onClick={showPolicies}
            style={{ background: "none", border: "none", color: "#60a5fa", cursor: "pointer", textDecoration: "underline" }}>
            Leer más
          </button>
        </div>
        <button 
          onClick={handleAccept}
          style={{
            backgroundColor: "#2563eb",
            color: "white",
            border: "none",
            padding: "0.5rem 1.5rem",
            borderRadius: "0.375rem",
            cursor: "pointer",
            fontWeight: "bold"
          }}>
          Entendido y Acepto
        </button>
      </div>

      <AppModal 
        isOpen={modal.isOpen}
        title={modal.title}
        message={modal.message}
        type={modal.type}
        onClose={() => setModal({ ...modal, isOpen: false })}
      />
    </>
  );
}
